import 'swiper/swiper.min.css';
import './assets/boxicons-2.0.7/css/boxicons.min.css';
import './App.scss';

import { BrowserRouter, Route } from 'react-router-dom';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';

import Routes from './config/Routes';
import { TrailerModal } from './components/hero-slide/HeroSlide';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { auth, db } from './firebase';
import { login } from './features/user/userSlice';
import { doc, getDoc } from '@firebase/firestore';
import Notify from './components/notify/Notify';

function App() {
   const dispatch = useDispatch();
   useEffect(() => {
     const unSub = auth.onAuthStateChanged(async (user) => {
       if (user) {
         const userDb = await getDoc(doc(db, "users", user.uid));
        const {bookingList} = userDb.data()
         dispatch(
           login({
             email: user.email,
             uid: user.uid,
             displayName: user.displayName,
             bookingList
           })
         );
       }
     });
     return () => unSub();
   }, []);




        return (
        <BrowserRouter>
            <Route render={props => (
                <> 
                    <Header {...props}/>
                    <Routes/>
                    <Footer/>
                    <TrailerModal />
                    <Notify/>
                </>
            )}/>
        </BrowserRouter>
    );
}

export default App;
